<app-stepper [currentStep]="currentStep" (stepChanged)="onStepChanged($event)"></app-stepper>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
      <app-vehicle-data *ngIf="currentStep === StepKey.Vehicle" [form]="vehicleData" (vehicleDataCompleted)="onVehicleDataReceived($event)"></app-vehicle-data>
      <app-pickup *ngIf="currentStep === StepKey.Pickup" [form]="locationInfo" (locationDataCompleted)="OnLocationInfoReceived($event)" (productCatalogResponseEvent)="receiveProductCatalogResponse($event)">
          <app-back-button
          slot="left-button"
          left-button
          [currentStep]="currentStep"
          [firstStep]="StepKey.Vehicle"
          (goBack)="goBack()"
        ></app-back-button>
      </app-pickup>
      <app-catalog *ngIf="currentStep === StepKey.Catalog" [form]="productSelection" [productCatalog]="productCatalogResponse">
        <app-back-button
        slot="left-button"
        left-button
        [currentStep]="currentStep"
        [firstStep]="StepKey.Vehicle"
        (goBack)="goBack()"
      ></app-back-button>
      </app-catalog>
      <app-summary *ngIf="currentStep === StepKey.DateTime" (sendSummaryData)="onSummaryDataReceived($event)">
        <app-back-button
        slot="left-button"
        left-button
        [currentStep]="currentStep"
        [firstStep]="StepKey.Vehicle"
        (goBack)="goBack()"
      ></app-back-button>
      </app-summary>
      <app-extras *ngIf="currentStep === StepKey.Extras" [mappedToppings]="mappedToppings" (nextStep)="onExtrasReceived($event)">
        <app-back-button
        slot="left-button"
        left-button
        [currentStep]="currentStep"
        [firstStep]="StepKey.Vehicle"
        (goBack)="goBack()">
      </app-back-button>
      </app-extras>
      <app-overview *ngIf="currentStep === StepKey.Overview">
        <app-back-button
        slot="left-button"
        left-button
        [currentStep]="currentStep"
        [firstStep]="StepKey.Vehicle"
        (goBack)="goBack()">
      </app-back-button>
      </app-overview>
</form>
